import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

type Props = { children: ReactNode; element?: Element };

const Portal = ({ children, element }: Props): JSX.Element | null => {
  return typeof document === 'object'
    ? createPortal(children, element || document.body)
    : null;
};

export default Portal;
